import { createContext } from "react";

const spotReviewContext = createContext();

export default spotReviewContext;
